var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.type == 'sat')?_c('SatForm',{staticClass:"form",attrs:{"company":_vm.company}}):_vm._e(),(_vm.type == 'logistics')?_c('LogisticsForm',{staticClass:"form",attrs:{"company":_vm.company}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }